import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  AppBar,
  Page,
  Footer,
  Benefits,
  Hero,
  ClassSchedule,
  AboutUs,
  Pricing,
  Testimonials,
  CTASection,
} from "../../components";

export const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) section.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.state]);

  return (
    <Page>
      <AppBar />
      <Hero />
      <AboutUs />
      <Benefits />
      <ClassSchedule />
      <Testimonials />
      <Pricing />
      <CTASection />
      <Footer />
    </Page>
  );
};
